import { render, staticRenderFns } from "./ItemsReceivedList.vue?vue&type=template&id=ed144f2c&scoped=true&"
import script from "./ItemsReceivedList.vue?vue&type=script&lang=js&"
export * from "./ItemsReceivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed144f2c",
  null
  
)

export default component.exports